import axios from "axios";

export const updateComponentsAPI = async (deviceId, components) => {
  await axios({
    url: `/api/v2/device/information/update-components`,
    method: "PUT",
    data: {
      device_id: deviceId,
      components: components
    }
  });
  return true;
};
